const accountTypes = {
    PRIVATE_CUSTOMER: 'normal_customer',
    BUSINESS_CUSTOMER: 'business_customer',
};

export default accountTypes;
